import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'

async function genericGETJson (url = '', data = {}, params = null) {
  if (process.env.VUE_APP_ENVIRONMENT === 'tests') {
    return new Promise((resolve, reject) => {
      const data = mock.getCompanies
      const pages = data.data.length

      const clone = JSON.parse(JSON.stringify(data))
      clone.data = clone.data.slice(0, params.limit)

      clone.meta.total = pages

      resolve(clone)
    })
  } else {
    const req = {
      url,
      method: 'GET',
      headers: {
        'Content-type': 'application/json',
        'access-control-allow-origin': '*'
      },
      data,
      params
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { genericGETJson }
